import React from "react";
import ReactDOM from "react-dom/client";
import "./apiBase";
import App from "./App";
import "./styles.css";
import "./theme-sanguo.css";
import "./theme-white-jade.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
